import React from "react";
import { Redirect } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Link from "@mui/material/Link";
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import { Box, Button, Paper } from '@mui/material';

import { withStyles } from '@mui/styles';
import DashboardTemplate from "../components/templates/DashboardTemplate";
import MixpanelOnload from "../components/MixpanelOnload";
import MixpanelButton from "../components/MixpanelButton";

import GA from '../utils/GoogleAnalytics';
const moment = require('moment');

const useStyles = theme => ({
    '@global': {
    },
    paper: {
        padding: '8px',
    },
    'catchIcon': {
        fontSize: '3rem !important',
        marginRight: '10px',
        lineHeight: '6rem'
    },
    'calculatedPrice': {
        fontSize: '2rem',
        fontWeight: 'bold',
    },
    sectionTitle: {
        color: '#FFFFFF',
        fontSize: '1.5rem',
        padding: '10px',
    },
    sectionBox: {
        background: '#7c7b7b',
        borderRadius: '10px',
    }
});

class ChangePlan extends React.Component {

    constructor() {
        super();
        this.state = {
            redirect: false,
            productName: "Loading",
            hasPlan: false,
            hasPaymentMethod: false,
            isTrial: true,
            startTimestamp: new Date().getTime() / 1000,
            trialEndTimestamp: new Date().getTime() / 1000 + 14 * 24 * 3600 * 1000,
            trialRemains: 14,
            planType: 21,
            productId: 5,
            unitCount: 10,
            // for 
            setPlan: true,
            isOldPlan: false,
            currentProductName: "Loading",
            currentUnitCount: 10,
            currentPrice: 30,
            totalPrice: 'loading',
            discountPrice: 30,
            discounted: false,
            nextPaymentDate: '',
            isMonthly: true
        };
        this.getAccount = this.getAccount.bind(this);
    }

    handlePlanTypeChange = (isMonthly) => {
        this.setState({ isMonthly });
    }

    componentDidMount() {
        this.getAccount();
    }

    setCompletePlan() {
        this.setState({
            completePlan: true
        })
    }

    getAccount() {
        fetch('/api/account')
            .then(res => res.json())
            .then(data => {
                // TODO set flags
                console.log(data);
                if (data.planType) {
                    this.setState({ planType: data.planType });
                    this.setState({ productId: data.productId });
                    this.setState({ currentProductName: data.productName });
                    this.setState({ currentUnitCount: data.unitCount });
                    this.setState({ currentPrice: this.getTotalPrice(data.unitCount, false) })
                    this.setState({ nextPaymentDate: moment(data.nextPaymentTimestamp * 1000).format('YYYY-MM-DD') });
                    this.setState({ trialEndDate: moment(data.trialEndTimestamp * 1000).format('YYYY-MM-DD') });
                    this.setState({ hasPlan: true });
                    this.setState({ hasPaymentMethod: data.hasPaymentMethod });
                    this.setState({ isOldPlan: data.isOldPlan });
                    this.setState({ isTrial: data.isTrial });
                    if (this.state.isOldPlan) {
                        this.setState({ setPlan: false });
                        if (this.state.planType === 1) {
                            console.log('set price for personal plan')
                            this.setState({ totalPrice: 35 });
                            this.setState({ currentPrice: 35 });
                        }
                        else {
                            console.log('set price for free plan')
                            this.setState({ totalPrice: 0 });
                            this.setState({ currentPrice: 0 });
                        }
                        return;
                    }
                    else {
                        this.setState({ setPlan: true });
                        this.setUnitCount(data.unitCount);
                    }
                }
                else {
                    this.setState({ hasPlan: false });
                    this.setState({ setPlan: true });
                    this.setState({ isTrial: true });
                    this.setUnitCount(this.state.unitCount);
                }
            })
            .catch(err => {
                console.log(err);
                this.setState({ hasPlan: false });
                this.setState({ setPlan: true });
                this.setState({ isTrial: true });
                this.setUnitCount(this.state.unitCount);
            })
    }

    handleSubmit = event => {
        event.preventDefault();
        if (this.state.productId === 1 || this.state.productId === 2) {
            // old type
        }
        GA.Event('Dashboard', 'Change user count', 'changePlan');
        fetch("/api/plan/setPlan", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'planType': this.state.planType,
                'productId': this.state.productId,
                'unitCount': this.state.unitCount,
            })
        })
            .then((res) => {
                console.log(res);
                console.log(this);
                if (res.status === 200) {
                    // do redirect
                    this.setState({ 'redirect': true });
                }
                else {
                    alert('something went wrong, please contact through chat');
                }
            })
            .catch((e) => {
                console.log(e);
                alert(e);
            })
    };

    getTotalPrice = (unitCount, withDiscount = true) => {
        if (withDiscount && unitCount >= 100) {
            return unitCount * 240 / 100;
        }
        return unitCount * 3;
    }
    setUnitCount = (newUnitCount) => {
        this.setState({ unitCount: newUnitCount });
        const price = this.getTotalPrice(newUnitCount, false);
        this.setState({ totalPrice: price });
        if (newUnitCount === 15) {
            const discountPrice = this.getTotalPrice(newUnitCount, true);
            this.setState({ discountPrice: discountPrice, discounted: true });
            this.setState({ planType: 21 });
            this.setState({ productId: 5 });
            this.setState({ productName: "Small_Monthly" });
        }
        else {
            this.setState({ discountPrice: price, discounted: false });
            this.setState({ planType: 21 });
            this.setState({ productId: 6 });
            this.setState({ productName: "Business_Monthly" });
        }
    }

    handleInputChange = (price, title) => {
        const unitCount = price === "45" ? 15 : 33;
        this.setState({
            selectedPlan: title
        }, () => {
            if (unitCount) {
                this.setUnitCount(unitCount);
            }
        }
        );
    }


    handleBlur = () => {
        if (this.unitCount < 0) {
            this.setUnitCount(0);
        }
    }

    planSelectForm = () => {
        const { isMonthly } = this.state;
        return <Box sx={{ maxWidth: 900, margin: 'auto', p: 2 }}>
            <Typography variant="h6" style={{ color: "#FF2B01" }} align="center" fontWeight="bold" mb={2}>
                <Button
                    onClick={() => this.handlePlanTypeChange(true)}
                    style={{ color: isMonthly ? "#FF2B01" : "inherit" }}
                >
                    Monthly
                </Button>
                {" / "}
                <Button
                    onClick={() => this.handlePlanTypeChange(false)}
                    style={{ color: !isMonthly ? "#FF2B01" : "inherit" }}
                >
                    Yearly
                </Button>
                <span style={{ backgroundColor: '#FF2B01', color: 'white', padding: '2px 5px', marginLeft: '5px' }}>
                    -12% off
                </span>
            </Typography>
            {isMonthly ? this.renderMonthlyPlans() : this.renderYearlyPlans()}
        </Box>
    }

    prependItems = () => {
        return <div>
            <Typography variant="h5" component="h2" align="center" marginTop="30px" marginBottom="30px">
                Change your plan
            </Typography>
        </div>
    }
    appendItems = () => {
        return
    }

    renderButton = (plan) => {
        const mixpanelMessage = 'kiara_app_com_setup_plan_button';
        if (plan.title === "Enterprise") {
            return (
                <Link href="https://www.getkiara.com/contact" style={{ textDecoration: 'none', width: '100%' }}>
                    <MixpanelButton
                        mixpanelMessage={mixpanelMessage}
                        variant={this.state.selectedPlan === plan.title ? "contained" : "outlined"}
                        style={{
                            backgroundColor: this.state.selectedPlan === plan.title ? "#FF2B01" : "transparent",
                            color: this.state.selectedPlan === plan.title ? "#FFFFFF" : "#FF2B01",
                            borderColor: "#FF2B01",
                            width: '100%'
                        }}
                    >
                        Contact Us
                    </MixpanelButton>
                </Link>
            );
        } else {
            return (
                <MixpanelButton
                    mixpanelMessage={mixpanelMessage}
                    variant={this.state.selectedPlan === plan.title ? "contained" : "outlined"}
                    style={{
                        backgroundColor: this.state.selectedPlan === plan.title ? "#FF2B01" : "transparent",
                        color: this.state.selectedPlan === plan.title ? "#FFFFFF" : "#FF2B01",
                        borderColor: "#FF2B01",
                    }}
                    fullWidth
                    onClick={() => this.handleInputChange(plan.price, plan.title)}
                >
                    Choose
                </MixpanelButton>
            );
        }
    }

    renderMonthlyPlans = () => {
        return (
            <Box>
                <Grid container spacing={3} sx={{ mb: 6 }}>
                    {[
                        { title: "Small", price: "45", description: "Up to 60 Members Unlimited Use", isSelected: true },
                        { title: "Business", price: "99", description: "Up to 330 Members Unlimited Use", isSelected: false },
                        { title: "Enterprise", price: "Customize", description: "For those who pre-selected a custom plan via email", isSelected: false }
                    ].map((plan, index) => (
                        <Grid item xs={12} sm={4} key={index}>
                            <Paper elevation={3} sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
                                <Typography variant="h5" component="h2" fontWeight="bold" gutterBottom>
                                    {plan.title}
                                </Typography>
                                <Typography variant="h4" component="p" style={{ color: "#FF2B01" }} fontWeight="bold" gutterBottom>
                                    ${plan.price}
                                </Typography>
                                <Typography variant="body2" sx={{ mb: 2, flexGrow: 1 }}>
                                    {plan.description}
                                </Typography>
                                {this.renderButton(plan)}
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                    <Button
                        variant="contained"
                        size="small"
                        style={{
                            backgroundColor: "#FF2B01",
                            color: "#FFFFFF",
                            borderColor: "#FF2B01",
                            width: 'auto',
                            minWidth: '200px',
                            maxWidth: '300px'
                        }}
                        onClick={this.handleSubmit}
                    >
                        Confirm
                    </Button>
                </Box>
            </Box>
        );
    }

    renderYearlyPlans = () => {
        return (
            <Grid container spacing={3} sx={{ mb: 6 }}>
                {[
                    { title: "Small", price: "$475", description: "Up to 60 Members Unlimited Use" },
                    { title: "Business", price: "$1045", description: "Up to 330 Members Unlimited Use" },
                    { title: "Enterprise", price: "Customize", description: "For those who pre-selected a custom plan via email" }
                ].map((plan, index) => (
                    <Grid item xs={12} sm={4} key={index}>
                        <Paper elevation={3} sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="h5" component="h2" fontWeight="bold" gutterBottom>
                                {plan.title}
                            </Typography>
                            <Typography variant="h4" component="p" style={{ color: "#FF2B01" }} fontWeight="bold" gutterBottom>
                                {plan.price}
                            </Typography>
                            <Typography variant="body2" sx={{ mb: 2, flexGrow: 1 }}>
                                {plan.description}
                            </Typography>
                        </Paper>
                    </Grid>
                ))}
                <Typography variant="body1" style={{ marginTop: '30px' }} >
                    For a 12-month advance payment by invoice, please contact us through the chat, email us at{' '}
                    <Link href="mailto:hello@kiara.team" color="primary">
                        hello@kiara.team
                    </Link>
                    , or use the{' '}
                    <Link href="https://www.getkiara.com/contact" target="_blank" rel="noopener noreferrer" color="primary">
                        contact form
                    </Link>
                </Typography>
            </Grid>
        );
    }


    // no plan -> urges to select plan
    // no payment -> 
    // under trial -> shows period
    // under free plan -> 
    render() {
        const { redirect } = this.state;
        const { isOldPlan, currentProductName, currentUnitCount, currentPrice } = this.state;
        const { classes } = this.props;

        if (redirect) {
            return <Redirect to="/change-finish" >
            </Redirect>
        }
        return (
            <DashboardTemplate maxWidth="md" prependItems={this.prependItems()} appendItems={this.appendItems()}>
                <div>
                    <CardContent>
                        <Box className={classes.sectionBox}>
                            <h3 className={classes.sectionTitle}>Your Plan</h3>
                        </Box>
                        <p>
                            <label>Current Plan: </label>
                            {currentProductName}
                        </p>
                        {isOldPlan || currentProductName !== 'Kiara Translator for Slack' ?
                            <span></span>
                            :
                            <p>
                                <label>User Count: </label>
                                {currentUnitCount}
                            </p>
                        }
                        {currentProductName === 'Small_Monthly' || currentProductName === 'Business_Monthly' ?
                            <p>
                                <label>Monthly payment: </label>
                                ${currentPrice}
                            </p>
                            : <span></span>
                        }

                        <Box className={classes.sectionBox} marginTop="60px">
                            <h3 className={classes.sectionTitle}>Change Plan</h3>
                        </Box>
                        {this.planSelectForm()}
                    </CardContent>
                    <MixpanelOnload message="kiara-app.com/change-plan" />
                </div>
            </DashboardTemplate>
        )
    }
}
export default withStyles(useStyles)(ChangePlan);
